import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { SurveyTemplates } from '../../containers/templates/SurveyTemplates';

/**
 * Admin Survey Library page - landing page for managing survey templates.
 * Follows the same pattern as AdminAutomationsPage.
 *
 * Routes:
 * - /surveys - Landing page with industry tiles
 * - /surveys/{Industry} - Industry-specific templates view
 */
export const AdminSurveyLibraryPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<SurveyTemplates />
		</AdminDashboardPageLayout>
	);
};
